import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError('');
    if (feedback.message) {
      setFeedback({ type: '', message: '' });
    }
  };

  const validateForm = () => {
    if (!email.trim()) {
      setError('Обязательное поле');
      return false;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Пожалуйста, введите корректный email');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    setFeedback({ type: '', message: '' });
    
    try {
      const response = await fetch('/api/v1/forgot_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setFeedback({
          type: 'success',
          message: data.message || 'Инструкции по восстановлению пароля отправлены на вашу электронную почту'
        });
        setEmail(''); // Clear the form
      } else {
        setFeedback({
          type: 'error',
          message: data.message || 'Произошла ошибка при отправке запроса'
        });
      }
    } catch (error) {
      setFeedback({
        type: 'error',
        message: 'Произошла ошибка при отправке запроса'
      });
      console.error('Error submitting forgot password request:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="flex justify-center my-5 py-5">
        <div className="w-full md:w-2/3 lg:w-1/2 bg-gray-200 py-5 px-5 rounded-lg pb-10">
          {feedback.message && (
            <div className={`mb-4 p-3 rounded ${feedback.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
              {feedback.message}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="w-full">
            <div className="flex flex-col items-center">
              <h2 className="text-2xl md:text-3xl font-bold mb-6">Восстановление пароля</h2>
              
              <div className="w-full px-0 lg:px-3 mb-6">
                <p className="text-gray-700 mb-4">
                  Введите адрес электронной почты, связанный с вашей учетной записью, и мы отправим вам ссылку для сброса пароля.
                </p>
              </div>
              
              <div className="w-full px-0 lg:px-3 mb-4">
                <label htmlFor="email" className="text-[#544a28] text-[13px] lg:text-base font-bold font-['Open Sans']">
                  Эл. почта
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  placeholder="Ваш email"
                  className={`w-full p-2 border rounded my-3 ${error ? 'border-red-500' : 'border-gray-300'}`}
                  required
                />
                {error && (
                  <div className="text-red-500 text-sm mt-1">{error}</div>
                )}
              </div>
              
              <div className="w-full px-0 lg:px-3 mb-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full py-2 px-4 bg-[#c0834d] text-white rounded hover:bg-[#a87442] transition-colors ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`}
                >
                  {isSubmitting ? 'Отправка...' : 'Отправить ссылку для сброса'}
                </button>
              </div>
              
              <div className="w-full px-0 lg:px-3 text-center">
                <Link to="/login" className="text-blue-600 hover:underline">
                  Вернуться на страницу входа
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 